import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/announcements/$announcementId")({
  component: lazyRouteComponent(
    () => import("@/pages/AnnouncementDetailPage"),
    "AnnouncementDetailPage",
  ),
});
